/* fields: перевод строк интерфейса. Ключ — русская строка ровно как в коде.
   Разделы: поля контактов, теги, шаблоны ответов, AI Prompts (+ их моки). */
const d: Record<string, string> = {
  "В поле ответа наберите «/» — появится список шаблонов; подстановки $contact.firstName и $user.name заменятся данными при отправке.": "Type “/” in the reply box to open the snippet list; $contact.firstName and $user.name are replaced with real data when sending.",
  "Напишите текст сообщения или приложите файл — это то, что получит клиент.": "Write the message text or attach a file — this is what the customer will receive.",
  "Файл «{name}» больше 10 МБ.": "File “{name}” is larger than 10 MB.",
  "Шаблон доступен всем сотрудникам вашего рабочего пространства: в поле ответа наберите «/» и выберите его.": "The snippet is available to everyone in your workspace: type “/” in the reply box and pick it.",
  // ── общее ──
  "янв": "Jan",
  "фев": "Feb",
  "мар": "Mar",
  "апр": "Apr",
  "мая": "May",
  "июн": "Jun",
  "июл": "Jul",
  "авг": "Aug",
  "сен": "Sep",
  "окт": "Oct",
  "ноя": "Nov",
  "дек": "Dec",
  "Доступы": "Access",
  "Название": "Name",
  "Описание": "Description",
  "Действия": "Actions",
  "Дублировать": "Duplicate",
  "Удалить": "Delete",
  "Отмена": "Cancel",
  "Сохранить": "Save",
  "Сохраняем…": "Saving…",
  "без названия": "untitled",
  "Узнать больше": "Learn more",
  "Такой ID уже занят — выберите другой": "This ID is already taken — choose another",
  "Раздел «{name}» пока не подключён": "Section “{name}” is not connected yet",
  "Раздел «{name}» в демо не открывается": "Section “{name}” is not available in the demo",

  // ── типы и видимость полей (fields-meta) ──
  "Текст": "Text",
  "Число": "Number",
  "Телефон": "Phone",
  "Дата": "Date",
  "Список значений": "List of values",
  "Изображение": "Image",
  "Да / Нет": "Yes / No",
  "Всегда показывать": "Always show",
  "Скрыто": "Hidden",
  "Только админ": "Admin only",

  // ── поля контактов ──
  "0 из 0": "0 of 0",
  "{from}–{to} из {total}": "{from}–{to} of {total}",
  "Латиница, цифры и _, начинается с буквы, без пробелов: phone, orderId": "Latin letters, digits and _, starts with a letter, no spaces: phone, orderId",
  "Поле «{label}» обновлено — карточки контактов уже показывают новый вид": "Field “{label}” updated — contact cards already show the new layout",
  "Поле «{label}» добавлено в карточку контакта — ID {key}": "Field “{label}” added to the contact card — ID {key}",
  "{label} (копия)": "{label} (copy)",
  "Копия поля «{label}» создана — ID {key}": "Copy of field “{label}” created — ID {key}",
  "«{label}»: {vis}": "“{label}”: {vis}",
  "Удалить поле «{label}»? Его значения будут стёрты из всех карточек контактов.": "Delete field “{label}”? Its values will be erased from all contact cards.",
  "Поле «{label}» удалено вместе со значениями в карточках": "Field “{label}” deleted along with its values in contact cards",
  "настройки → входящие → поля контактов": "settings → inbox → contact fields",
  "Полей: {n}": "Fields: {n}",
  "Загружаем поля…": "Loading fields…",
  "Поля заводят и меняют владелец и администраторы. Поля «Только админ» другим сотрудникам не показываются.": "Fields are created and edited by the owner and admins. “Admin only” fields are hidden from other staff.",
  "Поля контактов": "Contact fields",
  "Поля карточки контакта: тип, описание и кто их видит.": "Contact card fields: type, description and who can see them.",
  "Добавить поле": "Add field",
  "Настроить вид": "Customise view",
  "Вид таблицы": "Table view",
  "Показывать описание": "Show description",
  "Плотные строки": "Compact rows",
  "Поиск по полям контактов": "Search contact fields",
  "Найти поле: имя, телефон, город…": "Find a field: name, phone, city…",
  "ID поля": "Field ID",
  "Тип": "Type",
  "Видимость": "Visibility",
  "Добавлено": "Added",
  "системное": "built-in",
  "Действия с полем {label}": "Actions for field {label}",
  "Поле не найдено. Попробуйте другое название или добавьте новое.": "No field found. Try another name or add a new one.",
  "Полей на странице": "Fields per page",
  "Предыдущая страница": "Previous page",
  "Следующая страница": "Next page",
  "Изменения сохраняются сразу. Удаление поля стирает его значения во всех карточках.": "Changes are saved immediately. Deleting a field erases its values in all cards.",
  "У вас только просмотр: поля меняют владелец и администраторы.": "View only: fields are edited by the owner and admins.",
  "Изменить поле": "Edit field",
  "Сменить видимость": "Change visibility",
  "Встроенное поле нельзя удалить — его можно скрыть": "A built-in field cannot be deleted — it can be hidden",
  "Удалить поле": "Delete field",
  "Закрыть окно поля": "Close field dialog",
  "Настройка поля": "Field settings",
  "Новое поле": "New field",
  "Поле «{label}»": "Field “{label}”",
  "Добавить поле контакта": "Add contact field",
  "Например, Город доставки": "e.g. Delivery city",
  "ID поля после создания не меняется": "The field ID cannot be changed after creation",
  "Что здесь хранится и зачем продавцу": "What is stored here and why a salesperson needs it",
  "Варианты": "Options",
  "Через запятую: опт, розница, дилер": "Comma-separated: wholesale, retail, dealer",
  "Встроенное поле: название, описание и видимость можно менять; удалить и сменить тип нельзя — на нём держится карточка контакта.": "Built-in field: name, description and visibility can be changed; it cannot be deleted or have its type changed — the contact card depends on it.",
  "Поле появится в карточке контакта, в импорте и выгрузке CSV. ID поля после создания не меняется.": "The field will appear in the contact card, CSV import and export. The field ID cannot be changed after creation.",

  // ── теги (tags-meta: цвета) ──
  "Графит": "Graphite",
  "Коралловый": "Coral",
  "Янтарный": "Amber",
  "Лимонный": "Lemon",
  "Зелёный": "Green",
  "Бирюзовый": "Teal",
  "Розовый": "Rose",
  "Лаймовый": "Lime",

  // ── теги ──
  "Такой тег уже есть — выберите другое название": "This tag already exists — choose another name",
  "Тег «{name}» обновлён — метка на контактах осталась прежней": "Tag “{name}” updated — contacts keep the label",
  "Тег «{name}» создан — его можно повесить на контакт": "Tag “{name}” created — you can add it to a contact",
  "{name} (копия)": "{name} (copy)",
  "{name} (копия {n})": "{name} (copy {n})",
  "Создана копия тега «{name}» — на контактах пока не стоит": "Copy of tag “{name}” created — not on any contact yet",
  "Тег «{name}» удалён — метка снята с {count}, сами контакты на месте": "Tag “{name}” deleted — removed from {count}, the contacts remain",
  "контактов": "contact|contacts",
  "Тег «{name}» удалён": "Tag “{name}” deleted",
  "настройки → входящие → теги": "settings → inbox → tags",
  "Тегов: {n}": "Tags: {n}",
  "Загружаем теги…": "Loading tags…",
  "Теги создают и меняют владелец, администраторы и менеджеры. Агенты вешают их на контакты, но не меняют список.": "Tags are created and edited by the owner, admins and managers. Agents add them to contacts but cannot change the list.",
  "Теги": "Tags",
  "Создавайте и управляйте тегами, чтобы раскладывать контакты по темам: оплата, доставка, возврат.": "Create and manage tags to sort contacts by topic: payment, delivery, refund.",
  "Тег вешается на контакт в его карточке или массово из списка контактов. По тегу работает фильтр в контактах.": "A tag is added to a contact in its card or in bulk from the contact list. Contacts can be filtered by tag.",
  "Создать тег": "Create tag",
  "Поиск по тегам": "Search tags",
  "Найти тег: оплата, возврат…": "Find a tag: payment, refund…",
  "Тег": "Tag",
  "Контактов": "Contacts",
  "Создан": "Created",
  "Без описания": "No description",
  "Действия с тегом {name}": "Actions for tag {name}",
  "Тегов не найдено": "No tags found",
  "Тегов пока нет": "No tags yet",
  "Измените запрос или создайте новый тег — с ним контакты проще фильтровать и передавать коллегам.": "Change your search or create a new tag — it makes contacts easier to filter and hand over to colleagues.",
  "Измените запрос. Новые теги заводят владелец, администраторы и менеджеры.": "Change your search. New tags are created by the owner, admins and managers.",
  "тегов": "tag|tags",
  "{tags} · на контактах {used}": "{tags} · {used} on contacts",
  "Фильтр в контактах: тег": "Contact filter: tag",
  "Изменения сохраняются сразу. Удаление тега снимает его со всех контактов.": "Changes are saved immediately. Deleting a tag removes it from all contacts.",
  "У вас только просмотр: теги меняют владелец, администраторы и менеджеры.": "View only: tags are edited by the owner, admins and managers.",
  "Изменить тег": "Edit tag",
  "Закрыть окно тега": "Close tag dialog",
  "Настройка тега": "Tag settings",
  "Новый тег": "New tag",
  "Тег «{name}»": "Tag “{name}”",
  "Теги помогают раскладывать контакты по темам. Их видно в карточке контакта и в фильтрах.": "Tags help sort contacts by topic. They are shown in the contact card and in filters.",
  "Эмодзи": "Emoji",
  "Выбрать эмодзи для тега": "Choose an emoji for the tag",
  "Эмодзи тега": "Tag emoji",
  "Эмодзи {e}": "Emoji {e}",
  "Название тега": "Tag name",
  "Цвета": "Colours",
  "Цвет: {color}": "Colour: {color}",
  "Опишите тег": "Describe the tag",
  "Придумайте название — по нему тег ищут в фильтрах.": "Enter a name — it is used to find the tag in filters.",
  "Тег виден всем сотрудникам рабочего пространства. Удаление тега не удаляет контакты — метка просто снимается.": "The tag is visible to everyone in the workspace. Deleting a tag does not delete contacts — the label is simply removed.",
  "Удалить тег «{name}»?": "Delete tag “{name}”?",
  "Метка снимется с {count}. Сами контакты и переписка останутся.": "It will be removed from {count}. The contacts and conversations remain.",
  "Тег пока не стоит ни на одном контакте, ничего не потеряется.": "The tag is not on any contact yet, nothing will be lost.",
  "Удалить тег": "Delete tag",

  // ── шаблоны: навигация макета (mocks/snippets) ──
  "Рабочее пространство": "Workspace",
  "Дашборд": "Dashboard",
  "Общие сведения": "General",
  "Настройки пользователей": "User settings",
  "Настройки команды": "Team settings",
  "Приложения": "Apps",
  "Каналы": "Channels",
  "Интеграции": "Integrations",
  "Виджеты": "Widgets",
  "Настройки входящих": "Inbox settings",
  "Жизненный цикл": "Lifecycle",
  "Диалоги": "Conversations",
  "Шаблоны": "Snippets",
  "Звонки": "Calls",
  "Данные": "Data",
  "Файлы": "Files",
  "Импорт контактов": "Import contacts",
  "Экспорт данных": "Export data",

  // ── шаблоны: темы и демо-данные ──
  "Поддержка": "Support",
  "Продажи": "Sales",
  "Оплата": "Payment",
  "Доставка": "Delivery",
  "Приветствие": "Greeting",
  "Привет, $contact.firstName! Меня зовут Анна, я из команды Hub. Чем можем помочь?": "Hi $contact.firstName! My name is Anna, I'm from the Hub team. How can we help?",
  "Прайс и условия": "Price list and terms",
  "Отправляю актуальный прайс на 2026 год. Тариф «Команда» — 1 490 ₽ за пользователя в месяц, при оплате за год скидка 20%. Если удобно, соберу расчёт под вашу команду.": "Here is the current 2026 price list. The “Team” plan is 1,490 ₽ per user per month, with a 20% discount for annual billing. If you like, I can put together a quote for your team.",
  "Реквизиты для оплаты": "Payment details",
  "Счёт готов и приложен к сообщению. Оплатить можно по ссылке из документа, назначение платежа менять не нужно. После оплаты пришлите, пожалуйста, платёжное поручение — сразу закроем доступ.": "The invoice is ready and attached. You can pay via the link in the document; no need to change the payment reference. Once paid, please send the payment confirmation — we'll activate your access right away.",
  "Сроки подключения": "Setup time",
  "Номер WhatsApp подключается по QR-коду за 2–3 минуты, Telegram — по токену бота. Если нужна помощь с настройкой, наш инженер подключится к созвону в течение рабочего дня.": "A WhatsApp number connects via QR code in 2–3 minutes, Telegram via a bot token. If you need help with setup, our engineer will join a call within the business day.",
  "Приглашение на демо": "Demo invitation",
  "Предлагаю 30 минут демо: покажу единую ленту WhatsApp и Telegram, переназначение диалогов и шаблоны ответов. Когда вам удобно — завтра в 11:00 или в 16:00?": "How about a 30-minute demo: I'll show the unified WhatsApp and Telegram feed, conversation reassignment and reply snippets. What works for you — tomorrow at 11:00 or 16:00?",
  "Закрытие диалога": "Closing a conversation",
  "Спасибо за обращение! Если появятся вопросы — просто ответьте в этом чате, мы на связи в рабочее время.": "Thanks for reaching out! If you have any questions, just reply in this chat — we're available during business hours.",

  // ── шаблоны: экран ──
  "Латинские буквы и цифры, без пробелов: greeting, price-2026": "Latin letters and digits, no spaces: greeting, price-2026",
  "Шаблон «{name}» обновлён — в диалогах он уже доступен по /{id}": "Snippet “{name}” updated — available in conversations via /{id}",
  "Шаблон «{name}» создан — наберите /{id} в поле ответа": "Snippet “{name}” created — type /{id} in the reply box",
  "Копия шаблона создана — вызывается по /{id}": "Snippet copy created — call it with /{id}",
  "Шаблон «{name}» удалён — отправленные сообщения остаются в диалогах": "Snippet “{name}” deleted — sent messages stay in conversations",
  "Шаблон «{name}» вставлен в поле ответа в демо-чате — текст можно поправить перед отправкой": "Snippet “{name}” inserted into the reply box in the demo chat — you can edit the text before sending",
  "Сокращение /{id} скопировано — вставьте его в поле ответа": "Shortcut /{id} copied — paste it into the reply box",
  "настройки → входящие → шаблоны": "settings → inbox → snippets",
  "Шаблонов: {n}": "Snippets: {n}",
  "Шаблоны меняет администратор. Продавцы используют их в ответах, но не редактируют.": "Snippets are edited by an admin. Salespeople use them in replies but cannot edit them.",
  "Шаблоны ответов": "Reply snippets",
  "Сохранённые ответы с текстом и файлами. Наберите «/» и ID шаблона в поле ответа, чтобы вставить его в диалог.": "Saved replies with text and files. Type “/” and the snippet ID in the reply box to insert it into the conversation.",
  "Демо-режим: подробная справка по шаблонам в макете недоступна": "Demo mode: detailed snippet help is not available in the mockup",
  "Добавить шаблон": "Add snippet",
  "Поиск по шаблонам": "Search snippets",
  "Найти шаблон: приветствие, счёт…": "Find a snippet: greeting, invoice…",
  "Фильтр по теме": "Filter by topic",
  "Все темы": "All topics",
  "Демо-режим: импорт шаблонов из файла в макете недоступен": "Demo mode: importing snippets from a file is not available in the mockup",
  "Импорт шаблонов": "Import snippets",
  "Сообщение": "Message",
  "Тема": "Topic",
  "Обновлён": "Updated",
  "Скопировать сокращение": "Copy shortcut",
  "Без темы": "No topic",
  "Действия с шаблоном {name}": "Actions for snippet {name}",
  "Шаблонов не найдено": "No snippets found",
  "Измените запрос или тему, а если шаблона ещё нет — создайте его: сохранённые ответы экономят время на частых вопросах.": "Change your search or topic, or create the snippet if it does not exist yet — saved replies save time on frequent questions.",
  "Создать шаблон": "Create snippet",
  "шаблонов": "snippet|snippets",
  "тема «{topic}»": "topic “{topic}”",
  "Вызов в диалоге: /ID": "Call in a conversation: /ID",
  "Демо-режим: шаблоны меняются только в макете — отправленные сообщения и диалоги не затрагиваются.": "Demo mode: snippets change only in the mockup — sent messages and conversations are not affected.",
  "Изменить шаблон": "Edit snippet",
  "Вставить в диалог": "Insert into conversation",
  "Закрыть окно шаблона": "Close snippet dialog",
  "Настройка шаблона": "Snippet settings",
  "Новый шаблон": "New snippet",
  "Шаблон «{name}»": "Snippet “{name}”",
  "Шаблоны позволяют быстро отправлять сохранённые ответы с текстом и файлами. Наберите «/» и ID шаблона, чтобы вставить его.": "Snippets let you quickly send saved replies with text and files. Type “/” and the snippet ID to insert it.",
  "Например, Приветствие": "e.g. Greeting",
  "ID шаблона": "Snippet ID",
  "Привет, $contact.firstName! Чем можем помочь?": "Hi $contact.firstName! How can we help?",
  "Подстановки:": "Placeholders:",
  "— заменятся данными при отправке.": "— replaced with real data when sending.",
  "Тема (необязательно)": "Topic (optional)",
  "Файл (необязательно)": "File (optional)",
  "Добавить файл": "Add file",
  "Убрать файл {name}": "Remove file {name}",
  "До 5 файлов, каждый до 10 МБ — они приложатся к сообщению вместе с текстом.": "Up to 5 files, 10 MB each — they are attached to the message along with the text.",
  "Добавьте название — по нему шаблон ищут в диалоге.": "Add a name — it is used to find the snippet in a conversation.",
  "Напишите текст сообщения — это то, что получит клиент.": "Write the message text — this is what the client receives.",
  "Шаблон доступен всем сотрудникам вашего рабочего пространства. Файлы хранятся в разделе «Файлы».": "The snippet is available to everyone in your workspace. Files are stored in the “Files” section.",

  // ── AI Prompts: демо-данные (mocks/aiprompts) ──
  "Изменить тон": "Change tone",
  "Сделать ответ более профессиональным, дружелюбным, эмпатичным или прямым.": "Make the reply more professional, friendly, empathetic or direct.",
  "Перепиши ответ в нейтрально-профессиональном тоне: без сленга и лишних эмоций, но без канцелярита. Сохрани все факты, цены и сроки без изменений.": "Rewrite the reply in a neutral, professional tone: no slang or excess emotion, but no bureaucratic language either. Keep all facts, prices and dates unchanged.",
  "Перевод": "Translation",
  "Перевести сообщение на выбранный язык клиента.": "Translate the message into the client's chosen language.",
  "Переведи ответ на язык, на котором написал клиент. Не добавляй и не убирай факты, имена и суммы — переводи их дословно.": "Translate the reply into the language the client wrote in. Do not add or remove facts, names or amounts — translate them literally.",
  "Орфография и грамматика": "Spelling and grammar",
  "Автоматически исправить грамматику, орфографию и пунктуацию.": "Automatically fix grammar, spelling and punctuation.",
  "Исправь орфографию, пунктуацию и опечатки в черновике. Не меняй смысл, порядок предложений и цифры.": "Fix spelling, punctuation and typos in the draft. Do not change the meaning, sentence order or numbers.",
  "Упростить язык": "Simplify language",
  "Сделать сообщение проще для чтения и понимания.": "Make the message easier to read and understand.",
  "Разбей длинные предложения на короткие, убери сложные обороты. Пиши так, чтобы понял человек без технического бэкграунда.": "Split long sentences into short ones and remove complex phrasing. Write so that someone without a technical background understands.",
  "Тон": "Tone",
  "Как звучит ответ: дружелюбно, строго, коротко": "How the reply sounds: friendly, strict, brief",
  "Грамматика": "Grammar",
  "Орфография, пунктуация и опечатки": "Spelling, punctuation and typos",
  "Язык, на котором отвечаем клиенту": "The language we reply to the client in",
  "Формат": "Format",
  "Длина, списки, структура ответа": "Length, lists, reply structure",
  "Своё правило": "Custom rule",
  "Любая инструкция для ассистента": "Any instruction for the assistant",
  "Здраствуйте! Подскажыте пажалуста, сколько стоит тариф для 12 человек и можна ли оплатить по счёту???": "Helo! Culd you pleese tell me how much the plan costs for 12 people and can we pay by invoice???",
  "AI Prompts правит только черновик ответа — продавец всегда видит результат и отправляет его сам.": "AI Prompts only edit the reply draft — the salesperson always sees the result and sends it themselves.",

  // ── AI Prompts: экран ──
  "Иконка {icon}": "Icon {icon}",
  "Название — минимум 3 символа: по нему промпт выбирают в диалоге": "Name — at least 3 characters: it is used to pick the prompt in a conversation",
  "Промпт с таким названием уже есть — придумайте другое": "A prompt with this name already exists — choose another",
  "Опишите в одном предложении, что делает промпт — минимум 10 символов": "Describe in one sentence what the prompt does — at least 10 characters",
  "Инструкция для ассистента — минимум 20 символов, иначе правило не сработает": "Assistant instruction — at least 20 characters, otherwise the rule will not work",
  "Промпт «{name}» сохранён — новое правило применится к следующим черновикам": "Prompt “{name}” saved — the new rule applies to the next drafts",
  "Промпт «{name}» создан и включён — он появится в панели AI Prompts в диалоге": "Prompt “{name}” created and enabled — it will appear in the AI Prompts panel in a conversation",
  "Промпт «{name}» удалён — ассистент больше не будет применять это правило": "Prompt “{name}” deleted — the assistant will no longer apply this rule",
  "Все AI Prompts выключены — включите хотя бы один, иначе править черновик нечем": "All AI Prompts are off — enable at least one, otherwise there is nothing to edit the draft with",
  "Применили: {list}": "Applied: {list}",
  "настройки → входящие → AI Prompts": "settings → inbox → AI Prompts",
  "Включено {n} из {total}": "{n} of {total} enabled",
  "AI Prompts настраивает администратор. Продавцы включают готовые правила в поле ответа и проверяют текст перед отправкой.": "AI Prompts are set up by an admin. Salespeople enable ready-made rules in the reply box and check the text before sending.",
  "Используйте AI Prompts, чтобы настраивать и улучшать формулировки ответов.": "Use AI Prompts to adjust and improve the wording of replies.",
  "Демо-режим: подробная справка по AI Prompts в макете недоступна": "Demo mode: detailed AI Prompts help is not available in the mockup",
  "Добавить AI-промпт": "Add AI prompt",
  "Настройки AI Assist": "AI Assist settings",
  "Встроенный": "Built-in",
  "Свой": "Custom",
  "Изменить": "Edit",
  "Промпт {title}": "Prompt {title}",
  "Включено {n} из {total} · правила применяются к черновику ответа": "{n} of {total} enabled · rules apply to the reply draft",
  "Включили все AI Prompts — ассистент будет применять их к каждому черновику": "All AI Prompts enabled — the assistant will apply them to every draft",
  "Включить все": "Enable all",
  "Как это в диалоге": "How it looks in a conversation",
  "ОС": "OS",
  "Ольга Соколова": "Olga Sokolova",
  "Черновик ответа": "Reply draft",
  "Активные промпты": "Active prompts",
  "Все промпты выключены — ассистент не будет править текст.": "All prompts are off — the assistant will not edit the text.",
  "Применить": "Apply",
  "Черновик вернулся к исходному виду": "Draft reset to its original text",
  "Сбросить": "Reset",
  "Используйте AI Prompts, чтобы менять тон, исправлять грамматику, переводить или упрощать ответы. Выберите готовые или": "Use AI Prompts to change tone, fix grammar, translate or simplify replies. Pick the ready-made ones or",
  "создайте свой промпт": "create your own prompt",
  "Демо-режим: промпты меняются только в макете — настоящие ответы клиентам не отправляются.": "Demo mode: prompts change only in the mockup — no real replies are sent to clients.",
  "Закрыть окно промпта": "Close prompt dialog",
  "Свой промпт": "Custom prompt",
  "Новый AI-промпт": "New AI prompt",
  "Изменить промпт": "Edit prompt",
  "Ассистент применит правило к черновику ответа. Продавец увидит результат и сможет поправить его перед отправкой.": "The assistant applies the rule to the reply draft. The salesperson sees the result and can edit it before sending.",
  "Например, Сократить ответ": "e.g. Shorten the reply",
  "Что видит продавец": "What the salesperson sees",
  "Сделать ответ короче, оставив только суть": "Make the reply shorter, keeping only the essentials",
  "Инструкция для ассистента": "Assistant instruction",
  "Сократи ответ до трёх предложений. Оставь цены, сроки и ссылки без изменений.": "Shorten the reply to three sentences. Keep prices, dates and links unchanged.",
  "Иконка": "Icon",
  "Свой промпт можно выключить в любой момент — он останется в списке, но не будет применяться к ответам.": "A custom prompt can be turned off at any time — it stays in the list but is not applied to replies.",
  "Сохранить промпт": "Save prompt",
  "Создать промпт": "Create prompt",
  "Telegram (телефон или @ник)": "Telegram (phone or @nick)",
};
export default d;
